import AsyncStorage from '@react-native-async-storage/async-storage'
import {type QueryClient} from '@tanstack/react-query'

import {account} from '#/storage'
import {getContentSourceFromServer, setContentSourceOnServer} from './api'
import {type ContentSource, type GetContentSourceRes} from './types'

class ContentSourceService {
  /** Synchronous read from MMKV — use as placeholder while server fetch is in flight. */
  getCached(did: string): ContentSource | undefined {
    return account.get([did, 'contentSource'])
  }

  /** Synchronous write to MMKV. */
  setCached(did: string, source: ContentSource): void {
    account.set([did, 'contentSource'], source)
  }

  /** Fetch current source from the PDS. Used as the React Query queryFn. */
  fetch(
    accessJwt: string,
    options?: {signal?: AbortSignal},
  ): Promise<GetContentSourceRes> {
    return getContentSourceFromServer(accessJwt, options)
  }

  /**
   * Set a new source on the PDS, update the MMKV cache, then purge both
   * the in-memory and persisted query cache so stale cross-source content
   * is gone on the next render.
   */
  async set(
    accessJwt: string,
    source: ContentSource,
    did: string,
    queryClient: QueryClient,
  ): Promise<void> {
    await setContentSourceOnServer(accessJwt, source)
    this.setCached(did, source)
    queryClient.clear()
    await AsyncStorage.removeItem('queryClient-' + did)
  }
}

export const contentSourceService = new ContentSourceService()
